import { cn } from '../lib/cn';
import { initials } from '../lib/text';

const SIZES = {
  sm: 'h-6 w-6 rounded-md text-[10px]',
  md: 'h-8 w-8 rounded-lg text-xs',
  lg: 'h-11 w-11 rounded-xl text-sm',
};

/** Initials tile for a client or person. Decorative: always shown next to the name. */
export function Avatar({
  name,
  size = 'sm',
  className,
}: {
  name: string;
  size?: keyof typeof SIZES;
  className?: string;
}) {
  return (
    <span
      aria-hidden
      className={cn(
        'inline-grid shrink-0 place-items-center bg-subtle font-bold text-muted',
        SIZES[size],
        className,
      )}
    >
      {initials(name)}
    </span>
  );
}
